import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

// const cu = <b>تومان</b>
export { default as api } from './api'
export const priceSeparator = (price, ext = 'تومان') => {
    return price ? (
        <>
            <h4 style={{marginBottom:'unset'}}>{Number(price).toLocaleString()}</h4><b style={{ marginRight: '8px' }}>{ext}</b>
        </>
    )
        : 0
}

export const getErrorComponent = (errors, fieldName) => {
    return (errors[fieldName]) ? (
        <span className="input-error">{errors[fieldName]}</span>) : ''
}
export const getFaStatus = (status) => {
    switch (status) {

        case 'pending':
            return { 'name': 'پرداخت نشده', 'value': 20 }
            break;
        case 'processing':
            return { 'name': 'در حال پردازش', 'value': 60 }
            break;
        case 'courier':
            return { 'name': 'تحویل به پست', 'value': 80 }
            break;
        case 'upload_failed':
            return { 'name': 'رسید رد شده', 'value': 50 }
            break;
        case 'uploaded':
            return { 'name': 'رسید اپلود شده', 'value': 50 }
            break;
        case 'complete':
            return { 'name': 'تکمیل شده', 'value': 100 }
            break;
        case 'cancel':
            return { 'name': 'لغو شده', 'value': 100 }
            break;
    }
}

// fa-IR-u-nu-latn

// const json_date = {
//        'weekday': {
//            'long': date.toLocaleDateString('fa-IR', {weekday: 'long'}),
//            'short': date.toLocaleDateString('fa-IR', {weekday: 'short'}),
//            'narrow': date.toLocaleDateString('fa-IR', {weekday: 'narrow'}),
//        },
//        'era': {
//            'long': date.toLocaleDateString('fa-IR', {era: 'long'}),
//            'short': date.toLocaleDateString('fa-IR', {era: 'short'}),
//            'narrow': date.toLocaleDateString('fa-IR', {era: 'narrow'}),
//        },
//        'timeZoneName': {
//            'long': date.toLocaleDateString('fa-IR', {timeZoneName: 'long'}),
//            'short': date.toLocaleDateString('fa-IR', {timeZoneName: 'short'}),
//        },
//        'year': {
//            'numeric': date.toLocaleDateString('fa-IR', {year: 'numeric'}),
//            '2-digit': date.toLocaleDateString('fa-IR', {year: '2-digit'}),
//        },
//        'month': {
//            'numeric': date.toLocaleDateString('fa-IR', {month: 'numeric'}),
//            '2-digit': date.toLocaleDateString('fa-IR', {month: '2-digit'}),
//            'long': date.toLocaleDateString('fa-IR', {month: 'long'}),
//            'short': date.toLocaleDateString('fa-IR', {month: 'short'}),
//            'narrow': date.toLocaleDateString('fa-IR', {month: 'narrow'}),
//        },
//        'day': {
//            'numeric': date.toLocaleDateString('fa-IR', {day: 'numeric'}),
//            '2-digit': date.toLocaleDateString('fa-IR', {day: '2-digit'}),
//        },
//        'hour': {
//            'numeric': date.toLocaleDateString('fa-IR', {hour: 'numeric'}),
//            '2-digit': date.toLocaleDateString('fa-IR', {hour: '2-digit'}),
//        },
//        'minute': {
//            'numeric': date.toLocaleDateString('fa-IR', {minute: 'numeric'}),
//            '2-digit': date.toLocaleDateString('fa-IR', {minute: '2-digit'}),
//        },
//        'second': {
//            'numeric': date.toLocaleDateString('fa-IR', {second: 'numeric'}),
//            '2-digit': date.toLocaleDateString('fa-IR', {second: '2-digit'}),
//        }
//    }
const options = { year: 'numeric', month: 'long', day: 'numeric' };

export const persianDate = (raw_date) => {
    const time = new Date(raw_date).toLocaleDateString('fa-IR', options);
    time.replace(/([۰-۹])/g, token => String.fromCharCode(token.charCodeAt(0) - 1728));

    return time;
}

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    direction: 'rtl',
    borderRadius: 50,
    height: '16px',
    mt: 2, [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: '#f0f0f0',
    }, [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 50,
        backgroundColor: 'var(--primary)',
    }
}));

// date = persianDate(new Date())